module.exports = __webpack_public_path__ + "static/media/XLM.71c1c50d.svg";